import { render, staticRenderFns } from "./BudgetSummaryWidget.vue?vue&type=template&id=ca2e393a&"
import script from "./BudgetSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./BudgetSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports